import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast-host',
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './toast-host.component.html',
  styleUrl: './toast-host.component.scss',
})
export class ToastHostComponent {
  private readonly toastService = inject(ToastService);

  readonly toasts = this.toastService.toasts;

  readonly ariaLive = computed(() =>
    this.toasts().some((toast) => toast.type === 'error') ? 'assertive' : 'polite'
  );

  stackOffset(index: number): string {
    return `translateY(-${index * 4.5}rem)`;
  }

  alertVariant(type: string): string {
    if (type === 'default' || type === 'dark') {
      return 'info';
    }
    return type;
  }
}
